<template>
  <div :class="types==1? 'swiper1':'swiper1'">
    <swiper 
    :slidesPerView="1" 
    :autoplay="{ delay: 5000, disableOnInteraction: true }"
    :navigation="true" 
    :pagination="{ clickable: false  }"
    :scrollbar="{ draggable: false }" 
    :space-between="0" 
    :modules="modules" 
    @mouseenter="enter" 
    @mouseleave="leave" 
    @swiper="onSwiper" 
    @slideChange="onSlideChange">
      <swiper-slide v-for="(item, index) in params" :key="index" class="swiperItem">
            <img src="@/assets/computer/shouye/z151.jpg" />
            <!-- <div class="swiper_text ls1 ">
                <div class=" fw_3 color4 fs_03 pb_006">{{ item.text }}</div>
                <div class=" fw_6 color4 fs_01">{{ item.text1 }}</div>
                <div class=" fw_6 color4 fs_01">{{ item.text2 }}</div>
            </div> -->
            <img :src="item.img1" class="hzhb"/>
      </swiper-slide>
    </swiper>
    <div class="swiper_text ls1 wow animate__flipInX">
        <div class=" fw_3 color4 fs_03 pb_006">COOPERATION PARTNER</div>
        <div class=" fw_6 color4 fs_01">合作</div>
        <div class=" fw_6 color4 fs_01">伙伴</div>
    </div>
    <!-- <img src="@/assets/computer/shouye/Right.png" alt="" @click="rightClick" class="rightpng wow animate__fadeInRight"> -->
    <!-- <img src="@/assets/computer/shouye/Left.png" alt="" @click="leftClick" class="leftpng wow animate__fadeInLeft"> -->
  </div>
</template>

<script setup >
 import { useRouter } from 'vue-router'
  const router = useRouter()

import { ref,defineProps, toRaw ,onMounted} from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
// interface B {
//   img: string;
// }
const props = defineProps({
  arrList:Array,
  type:Number,
}
);
 const types = ref()
const params = ref("") // 用于接收参数
 
onMounted(()=>{
    console.log("props",props); // 输出父组件传递过来的所有数据
    params.value = props.arrList; // 接收参数
    types.value = props.type
})

let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
 
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
const onSwiper = (swiper) => {
  // console.log(swiper);
 
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
const rightClick=()=>{
    swiperNew.slidePrev()
}
const leftClick=()=>{
    swiperNew.slideNext()

}
const onSlideChange = () => {
  // console.log("slide change");
};
</script>
<style  scoped>

.swiper1{
  width: 100%;
  height: auto;
  position: relative;
  /* background-image: url('@/assets/computer/shouye/z151.jpg') no-repeat ;
  background-size: 100% 100%; */
}
img {
    width: 100%;
    height: 100%;
  }
 
.swiperItem {
   /* border: aqua solid 1px; */
   /* height: 200px; */
}
.swiperItem img{
  display: block;
   /* border: aqua solid 1px; */
   /* height: 200px; */
}
:deep( .swiper .swiper-pagination ) {
  margin-bottom: 0.3rem;
}
:deep( .swiper .swiper-button-prev ) {
  display: none!important;
}
:deep( .swiper .swiper-button-next){
    display: none!important;
}
:deep(.swiper-pagination) .swiper-pagination-bullet.swiper-pagination-bullet-active {
  /* background-color: rgb(229, 180, 127); */
  background-color: rgb(255, 255, 255);
  width: 0.3rem;
  height: 0.07rem;
  border-radius: 0.1rem;
}
 
:deep(.swiper-pagination-bullet) {
  /* //修改分页器圆点大小 */
  width: 0.07rem;
  height: 0.07rem;
  background-color: rgb(255, 255, 255);
  /* background-color: #fff !important; */
  border: 0.01rem solid #fff !important;
}
 
.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
:deep(.swiper-pagination-horizontal.swiper-pagination-bullets) .swiper-pagination-bullet {
  /* // 分页器远点之间的距离 */
  margin: 0 0.1rem;
}
 
:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  color: rgb(229, 180, 127);
}
.rightpng{
    position: absolute;
    top: 47%;
    right: 10%;
    width: 0.4rem;
    height: 0.4rem;
    z-index: 2;
}
.leftpng{
    position: absolute;
    top: 47%;
    left: 10%;
    width: 0.4rem;
    height: 0.4rem;
    z-index: 2;
}
.swiper_text{
    position: absolute;
    top: 0.3rem;
    left: 25%;
    width: 50%;
    text-align: center;
    z-index: 2;
}
.hzhb{
    position: absolute;
    top: 1.3rem;
    left: 15%;
    width: 70%;
    height: auto;
}

</style>
